import {
  resolve,
} from "@/components/charts/common";



export default function hydrator(parameters, data, chart) {

  const dashboards = resolve("dashboards.value", parameters);

  const items = resolve("dashboards.items", parameters);

  // alert(chart.getParentId());

  data.tabs = items.filter(item => dashboards.includes(item.id) && item.layout.id != chart.getParentId());
  // data.color = resolve("color.value", parameters);
  data.sliderColor = resolve("sliderColor.value", parameters);
  // console.log("data.tabs", data.tabs);
  try {
    // console.log('update ui');
    // chart.updateUI();
  } catch(error) {
    // 
  }
  
}
